/* ==========================================================================
   Svobodný krok — chování funnelu
   Bez knihoven. Vše degraduje na fungující odkazy, když JS selže.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.documentElement;
  var cfg = window.SKConfig || {};
  var money = function (cents) {
    var v = Math.round(cents / 100);
    return v.toLocaleString('cs-CZ') + ' Kč';
  };

  /* ---------- 1. Odhalení při scrollu ------------------------------------ */

  function initReveal() {
    var targets = document.querySelectorAll('.reveal, .reveal-stagger');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });

    targets.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 2. Hlavička a lepící lišta --------------------------------- */

  function initHeader() {
    var header = document.querySelector('[data-header]');
    var buybar = document.querySelector('[data-buybar]');
    var anchor = document.querySelector('[data-buybar-anchor]');
    if (!header && !buybar) return;

    var onScroll = function () {
      var y = window.pageYOffset;
      if (header) header.classList.toggle('is-stuck', y > 8);

      if (buybar) {
        var trigger = anchor ? anchor.getBoundingClientRect().bottom < 0 : y > 600;
        var atOffer = false;
        var offer = document.querySelector('[data-offer]');
        if (offer) {
          var r = offer.getBoundingClientRect();
          atOffer = r.top < window.innerHeight * 0.85 && r.bottom > 0;
        }
        buybar.classList.toggle('is-on', trigger && !atOffer);
      }
    };

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { onScroll(); ticking = false; });
    }, { passive: true });

    onScroll();
  }

  /* ---------- 3. FAQ ------------------------------------------------------ */

  function initFaq() {
    document.querySelectorAll('[data-faq-q]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.faq__item');
        var open = item.classList.contains('is-open');

        var group = btn.closest('[data-faq]');
        if (group && !open) {
          group.querySelectorAll('.faq__item.is-open').forEach(function (other) {
            other.classList.remove('is-open');
            other.querySelector('[data-faq-q]').setAttribute('aria-expanded', 'false');
          });
        }

        item.classList.toggle('is-open', !open);
        btn.setAttribute('aria-expanded', String(!open));
      });
    });
  }

  /* ---------- 4. Výběr balíčku ------------------------------------------- */

  var Offer = {
    current: null,

    init: function () {
      var forms = document.querySelectorAll('[data-offer]');
      if (!forms.length) return;

      forms.forEach(function (offer) {
        offer.querySelectorAll('[data-pack]').forEach(function (pack) {
          var input = pack.querySelector('input');
          if (!input) return;

          var select = function () { Offer.select(offer, pack); };
          pack.addEventListener('click', function (e) {
            if (e.target.tagName !== 'INPUT') { e.preventDefault(); input.checked = true; }
            select();
          });
          input.addEventListener('change', select);
          if (input.checked) Offer.select(offer, pack, true);
        });

        /* kdyby žádná varianta nebyla předvybraná, vezmeme první dostupnou */
        if (!offer.getAttribute('data-selected-id')) {
          var first = offer.querySelector('[data-pack]:not(.is-sold)');
          if (first) {
            var firstInput = first.querySelector('input');
            if (firstInput) firstInput.checked = true;
            Offer.select(offer, first, true);
          }
        }

        var submit = offer.querySelector('[data-offer-submit]');
        if (submit) {
          submit.addEventListener('click', function (e) {
            e.preventDefault();
            var id = offer.getAttribute('data-selected-id');
            if (!id) return;
            Cart.add(id, 1, submit);
          });
        }
      });
    },

    select: function (offer, pack, silent) {
      offer.querySelectorAll('[data-pack]').forEach(function (p) {
        p.classList.toggle('is-active', p === pack);
      });

      var id = pack.getAttribute('data-variant-id');
      var price = parseInt(pack.getAttribute('data-price'), 10) || 0;
      var label = pack.getAttribute('data-label') || '';

      offer.setAttribute('data-selected-id', id);
      Offer.current = { id: id, price: price, label: label };

      /* shrnutí */
      var sum = offer.querySelector('[data-sum-total]');
      if (sum) sum.textContent = money(price);
      var sumLabel = offer.querySelector('[data-sum-label]');
      if (sumLabel) sumLabel.textContent = label;

      /* lepící lišta drží stejnou cenu jako výběr */
      document.querySelectorAll('[data-buybar-price]').forEach(function (el) {
        el.textContent = money(price);
      });
      document.querySelectorAll('[data-buybar-label]').forEach(function (el) {
        el.textContent = label;
      });

      if (!silent) pack.classList.remove('is-flash');
    }
  };

  /* ---------- 5. Košík ---------------------------------------------------- */

  var Cart = {
    drawer: null,
    scrim: null,
    lastFocus: null,

    init: function () {
      Cart.drawer = document.querySelector('[data-drawer]');
      Cart.scrim = document.querySelector('[data-drawer-scrim]');

      document.querySelectorAll('[data-cart-open]').forEach(function (el) {
        el.addEventListener('click', function (e) {
          e.preventDefault();
          Cart.refresh().then(Cart.open);
        });
      });

      if (Cart.scrim) Cart.scrim.addEventListener('click', Cart.close);

      document.querySelectorAll('[data-drawer-close]').forEach(function (el) {
        el.addEventListener('click', Cart.close);
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && Cart.drawer && Cart.drawer.classList.contains('is-open')) Cart.close();
      });

      /* jakékoli tlačítko "přidat do košíku" mimo výběr balíčku */
      document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-add]');
        if (!btn) return;
        e.preventDefault();
        Cart.add(btn.getAttribute('data-add'), parseInt(btn.getAttribute('data-qty'), 10) || 1, btn);
      });

      if (Cart.drawer) Cart.bindLines();
      Cart.refresh();
    },

    open: function () {
      if (!Cart.drawer) return;
      Cart.lastFocus = document.activeElement;
      Cart.drawer.classList.add('is-open');
      Cart.drawer.removeAttribute('aria-hidden');
      if (Cart.scrim) Cart.scrim.classList.add('is-open');
      root.classList.add('no-scroll');
      var close = Cart.drawer.querySelector('[data-drawer-close]');
      if (close) close.focus();
    },

    close: function () {
      if (!Cart.drawer) return;
      Cart.drawer.classList.remove('is-open');
      Cart.drawer.setAttribute('aria-hidden', 'true');
      if (Cart.scrim) Cart.scrim.classList.remove('is-open');
      root.classList.remove('no-scroll');
      if (Cart.lastFocus) Cart.lastFocus.focus();
    },

    add: function (id, qty, btn) {
      if (!id) return;
      if (btn) { btn.setAttribute('aria-busy', 'true'); }

      return fetch(cfg.routes.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status && data.status >= 400) throw new Error(data.description || 'Nepodařilo se přidat do košíku.');
          return Cart.refresh();
        })
        .then(function () {
          Cart.open();
          var badge = document.querySelector('[data-cart-count]');
          if (badge) {
            var btnEl = badge.closest('.cart-btn');
            if (btnEl) {
              btnEl.classList.remove('is-bumped');
              void btnEl.offsetWidth;
              btnEl.classList.add('is-bumped');
            }
          }
        })
        .catch(function (err) {
          window.alert(err.message || 'Něco se pokazilo, zkuste to prosím znovu.');
        })
        .finally(function () {
          if (btn) btn.removeAttribute('aria-busy');
        });
    },

    change: function (key, qty) {
      return fetch(cfg.routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function () { return Cart.refresh(); });
    },

    refresh: function () {
      return fetch(cfg.routes.cart + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          Cart.render(cart);
          return cart;
        })
        .catch(function () { return null; });
    },

    render: function (cart) {
      /* počet v hlavičce */
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.classList.toggle('is-on', cart.item_count > 0);
      });

      if (!Cart.drawer) return;

      var body = Cart.drawer.querySelector('[data-drawer-lines]');
      var foot = Cart.drawer.querySelector('[data-drawer-foot]');
      var empty = Cart.drawer.querySelector('[data-drawer-empty]');
      var bump = Cart.drawer.querySelector('[data-bump]');

      if (!cart.item_count) {
        if (body) body.innerHTML = '';
        if (foot) foot.hidden = true;
        if (empty) empty.hidden = false;
        if (bump) bump.hidden = true;
        Cart.ship(0);
        return;
      }

      if (empty) empty.hidden = true;
      if (foot) foot.hidden = false;

      if (body) {
        body.innerHTML = cart.items.map(function (item) {
          var img = item.image
            ? '<img src="' + item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=200" alt="" width="76" height="76" loading="lazy">'
            : '';
          var opt = (item.variant_title && item.variant_title !== 'Default Title')
            ? '<p class="line__opt">' + item.variant_title + '</p>' : '';

          return '' +
            '<div class="line" data-line="' + item.key + '">' +
              '<div class="line__media">' + img + '</div>' +
              '<div>' +
                '<p class="line__title">' + item.product_title + '</p>' + opt +
                '<div class="line__foot">' +
                  '<div class="qty">' +
                    '<button type="button" data-qty-down aria-label="Ubrat kus">&minus;</button>' +
                    '<span>' + item.quantity + '</span>' +
                    '<button type="button" data-qty-up aria-label="Přidat kus">+</button>' +
                  '</div>' +
                  '<span class="line__price">' + money(item.final_line_price) + '</span>' +
                '</div>' +
                '<button type="button" class="line__remove" data-line-remove>Odebrat</button>' +
              '</div>' +
            '</div>';
        }).join('');
      }

      /* mezisoučet */
      var total = Cart.drawer.querySelector('[data-drawer-total]');
      if (total) total.textContent = money(cart.total_price);

      /* nabídka navíc — skryjeme, když už je v košíku */
      if (bump) {
        var bumpId = Number(bump.getAttribute('data-bump-id'));
        var inCart = cart.items.some(function (i) { return i.variant_id === bumpId; });
        bump.hidden = !bumpId || inCart;
      }

      Cart.ship(cart.total_price);
    },

    ship: function (totalCents) {
      var box = document.querySelector('[data-ship]');
      if (!box) return;

      var threshold = (parseInt(cfg.freeShipping, 10) || 0) * 100;
      if (threshold <= 0) { box.hidden = true; return; }

      box.hidden = false;
      var fill = box.querySelector('[data-ship-fill]');
      var text = box.querySelector('[data-ship-text]');
      var missing = threshold - totalCents;

      if (missing <= 0) {
        if (fill) { fill.style.width = '100%'; fill.classList.add('is-done'); }
        if (text) { text.innerHTML = '<b>Doprava zdarma je vaše.</b>'; text.classList.add('is-done'); }
      } else {
        var pct = Math.max(6, Math.min(100, (totalCents / threshold) * 100));
        if (fill) { fill.style.width = pct + '%'; fill.classList.remove('is-done'); }
        if (text) {
          text.innerHTML = 'Do dopravy zdarma zbývá <b>' + money(missing) + '</b>';
          text.classList.remove('is-done');
        }
      }
    },

    bindLines: function () {
      Cart.drawer.addEventListener('click', function (e) {
        var line = e.target.closest('[data-line]');
        if (!line) return;
        var key = line.getAttribute('data-line');
        var qtyEl = line.querySelector('.qty span');
        var qty = parseInt(qtyEl ? qtyEl.textContent : '1', 10);

        if (e.target.closest('[data-qty-up]'))     Cart.change(key, qty + 1);
        if (e.target.closest('[data-qty-down]'))   Cart.change(key, Math.max(0, qty - 1));
        if (e.target.closest('[data-line-remove]')) Cart.change(key, 0);
      });
    }
  };

  /* ---------- 5b. Kolotoč recenzí ----------------------------------------- */

  function initCarousels() {
    document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
      var track = carousel.querySelector('[data-carousel-track]');
      var prev = carousel.querySelector('[data-carousel-prev]');
      var next = carousel.querySelector('[data-carousel-next]');
      if (!track) return;

      var scrollByCard = function (dir) {
        var card = track.querySelector(':scope > *');
        var amount = card ? card.getBoundingClientRect().width + 20 : track.clientWidth * 0.8;
        track.scrollBy({ left: amount * dir, behavior: 'smooth' });
      };

      if (prev) prev.addEventListener('click', function () { scrollByCard(-1); });
      if (next) next.addEventListener('click', function () { scrollByCard(1); });
    });
  }

  /* ---------- 6. Honeypot: tichá pojistka proti botům --------------------
     Shopify na formuláři 'customer' už sám filtruje podezřelé odesílání,
     tohle je jen rychlá klientská brzda navíc — když je vyplněné pole,
     které člověk nikdy nevidí, odeslání se potichu zastaví.               */

  function initHoneypot() {
    document.querySelectorAll('form[id^="newsletter-form-"]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        var trap = form.querySelector('input[name="contact[company]"]');
        if (trap && trap.value !== '') e.preventDefault();
      });
    });
  }

  /* ---------- 7. Plynulé skoky na kotvy ---------------------------------- */

  function initAnchors() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href^="#"]');
      if (!link) return;
      var id = link.getAttribute('href');
      if (id.length < 2) return;
      var target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      /* zvýrazníme cíl, aby bylo jasné, kam se člověk dostal */
      var pack = target.querySelector('[data-pack].is-active');
      if (pack) {
        pack.classList.remove('is-flash');
        void pack.offsetWidth;
        pack.classList.add('is-flash');
      }
    });
  }

  /* ---------- start ------------------------------------------------------- */

  function boot() {
    initReveal();
    initHeader();
    initFaq();
    initCarousels();
    initHoneypot();
    initAnchors();
    Offer.init();
    if (cfg.routes) Cart.init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
